import React from 'react';

import { Box } from '@mui/material';

export function TryBetaButton() {
  const currentUrl = window.location.href;
  const betaDomain = 'https://beta-admin.luxuryescapes.com';
  const adminDomain = 'https://admin.luxuryescapes.com';
  const testAdminDomain = 'https://test-admin.luxuryescapes.com';

  const { pathname, search, hash } = window.location;

  if (currentUrl.startsWith(betaDomain)) {
    const adminUrl = `${adminDomain}${pathname}${search}${hash}`;
    const testAdminUrl = `${testAdminDomain}${pathname}${search}${hash}`;

    return (
      <Box display="flex" gap={2}>
        <Box component="a" href={adminUrl} target="_blank" sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
          Try Prod
        </Box>
        <Box component="a" href={testAdminUrl} target="_blank" sx={{ textDecoration: 'underline', cursor: 'pointer' }}>
          Try Test
        </Box>
      </Box>
    );
  }

  const betaUrl = `${betaDomain}${pathname}${search}${hash}`;

  return (
    <Box component="a" href={betaUrl} target="_blank">
      Try beta
    </Box>
  );
}
